import { $workspaces } from "./states";
import { fetchWorkspaces } from "./effects";

$workspaces.on(fetchWorkspaces.doneData, (_, data) => data);
